import axios from '@/axios';

const RESOURCE_NAME = '/admin/keywords-blacklist';

export default {

    getKeywords(data) {
        return axios.post(`${RESOURCE_NAME}/get-keywords`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, {data})
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-keyword?id=${id}`)
    },
}
